__turbopack_context__.v({
  "contentWrapper": "SmoothScrollWrapper-module-scss-module__h1SaTW__contentWrapper",
  "routes": "SmoothScrollWrapper-module-scss-module__h1SaTW__routes",
  "stack-module-0": "SmoothScrollWrapper-module-scss-module__h1SaTW__stack-module-0",
  "stack-module-1": "SmoothScrollWrapper-module-scss-module__h1SaTW__stack-module-1",
  "stack-module-10": "SmoothScrollWrapper-module-scss-module__h1SaTW__stack-module-10",
  "stack-module-11": "SmoothScrollWrapper-module-scss-module__h1SaTW__stack-module-11",
  "stack-module-12": "SmoothScrollWrapper-module-scss-module__h1SaTW__stack-module-12",
  "stack-module-13": "SmoothScrollWrapper-module-scss-module__h1SaTW__stack-module-13",
  "stack-module-14": "SmoothScrollWrapper-module-scss-module__h1SaTW__stack-module-14",
  "stack-module-15": "SmoothScrollWrapper-module-scss-module__h1SaTW__stack-module-15",
  "stack-module-16": "SmoothScrollWrapper-module-scss-module__h1SaTW__stack-module-16",
  "stack-module-17": "SmoothScrollWrapper-module-scss-module__h1SaTW__stack-module-17",
  "stack-module-18": "SmoothScrollWrapper-module-scss-module__h1SaTW__stack-module-18",
  "stack-module-19": "SmoothScrollWrapper-module-scss-module__h1SaTW__stack-module-19",
  "stack-module-2": "SmoothScrollWrapper-module-scss-module__h1SaTW__stack-module-2",
  "stack-module-20": "SmoothScrollWrapper-module-scss-module__h1SaTW__stack-module-20",
  "stack-module-3": "SmoothScrollWrapper-module-scss-module__h1SaTW__stack-module-3",
  "stack-module-4": "SmoothScrollWrapper-module-scss-module__h1SaTW__stack-module-4",
  "stack-module-5": "SmoothScrollWrapper-module-scss-module__h1SaTW__stack-module-5",
  "stack-module-6": "SmoothScrollWrapper-module-scss-module__h1SaTW__stack-module-6",
  "stack-module-7": "SmoothScrollWrapper-module-scss-module__h1SaTW__stack-module-7",
  "stack-module-8": "SmoothScrollWrapper-module-scss-module__h1SaTW__stack-module-8",
  "stack-module-9": "SmoothScrollWrapper-module-scss-module__h1SaTW__stack-module-9",
  "z-base": "SmoothScrollWrapper-module-scss-module__h1SaTW__z-base",
  "z-content": "SmoothScrollWrapper-module-scss-module__h1SaTW__z-content",
  "z-footer": "SmoothScrollWrapper-module-scss-module__h1SaTW__z-footer",
  "z-header": "SmoothScrollWrapper-module-scss-module__h1SaTW__z-header",
  "z-hero": "SmoothScrollWrapper-module-scss-module__h1SaTW__z-hero",
  "z-logo": "SmoothScrollWrapper-module-scss-module__h1SaTW__z-logo",
  "z-logo-effect": "SmoothScrollWrapper-module-scss-module__h1SaTW__z-logo-effect",
  "z-navigation": "SmoothScrollWrapper-module-scss-module__h1SaTW__z-navigation",
  "z-sub": "SmoothScrollWrapper-module-scss-module__h1SaTW__z-sub",
});
